import Image from "next/image";

interface DemoGridComponentProps {
  theme: string | undefined;
}

export function DemoGridComponent({ theme = 'dark'} : DemoGridComponentProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      <Image
        priority
        className={
          'dark:border-primary/10 rounded-xl border border-gray-200'
        }
        width={414}
        height={896}
        src={`/images/${theme}-demo-1.webp`}
        alt={`App Image`}
      />
      <Image
        priority
        className={
          'dark:border-primary/10 rounded-xl border border-gray-200'
        }
        width={414}
        height={896}
        src={`/images/${theme}-demo-2.webp`}
        alt={`App Image`}
      />
      <Image
        priority
        className={
          'dark:border-primary/10 rounded-xl border border-gray-200'
        }
        width={414}
        height={896}
        src={`/images/${theme}-demo-3.webp`}
        alt={`App Image`}
      />
    </div>
  );
}